<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted } from "vue";
import { goBack } from "@/NavigationHelper";
import { AxiosResponse } from "axios";
import { createDownload, query2CSV } from "@/DataHelper";
import { showDialog } from "@/UIHelper";
import { globalsBezeichnung } from "@/local";
import { Globals } from "@/Globals";
import SelectZeitraum from "@/components/common/SelectZeitraum.vue";

const emit = defineEmits(["back", "save", "delete", "backDelete"]);
const props = defineProps<{
  title?: string;
  type?: string;
  exportAbfragen?: AbfrageItems[];
  queryAIC?: number;
}>();
let showLoading = ref<boolean>(false);
let apiAbfragen: AbfrageItems[] = [];
let separators: Array<{ label: string; sep: string }> = [
  { label: "; Strichpunkt", sep: ";" },
  { label: ", Komma", sep: "," },
  { label: "Tabstopp", sep: "\t" },
];
let separator: string = ";";

let selectedAPI: AbfrageItems = {
  aic: 0,
  bezeichnung: globalsBezeichnung(
    Globals.Begriff,
    "Web_Bitte_waehlen",
    "Bitte wählen"
  ),
};
let date: string = new Date().toISOString().substr(0, 7);
let pickerMulti: string[] = [new Date().toISOString().substr(0, 7)];
let landscape: boolean = true;
let startVal: any = AUApi.Current.zeitbereich.von;
let endVal: any = AUApi.Current.zeitbereich.bis;
let maxDate: string = "";
let multipleSelect: boolean = false;
let vecStamm: number[] = [];
let zeitbereich: APIZeitbereich | null = null;
let localeZeit: string = AUApi.Current.user.locale;
let file: File | null = null;
let localType = ref<string>("months");

onMounted(() => {
  if (props.type) {
    localType.value = props.type;
  }
  showLoading.value = true;
  if (props.exportAbfragen && props.exportAbfragen?.length > 0) {
    apiAbfragen = props.exportAbfragen;
    selectedAPI = apiAbfragen[0];
    showLoading.value = false;
  } else {
    AUApi.Current.getapiAbfragen(0).then((x: any) => {
      if (x.data) {
        apiAbfragen = x.data;
      }
      showLoading.value = false;
    });
  }
});
function downloadJson(fromDialog: boolean = false, tabMDialog?: any[]) {
  let currentZeitbereich = AUApi.Current.zeitbereich;
  if (pickerMulti?.length > 0) {
    const vals = pickerMulti.map((d) => new Date(d).valueOf());
    const von = new Date(Math.min(...vals));
    const bis = new Date(Math.max(...vals)).lastInMonth();
    let bereich = "Tag";
    if (localType.value === "month") {
      bereich = "Monat";
    } else if (localType.value === "year") {
      bereich = "Jahr";
    }
    currentZeitbereich = {
      bereich,
      von,
      bis,
    };
  }

  if (!currentZeitbereich) {
    const zeitbereichVon = AUApi.Current.zeitbereich.von;
    const zeitbereichBis = AUApi.Current.zeitbereich.bis;
    let bereich = "Tag";
    if (localType.value === "month") {
      bereich = "Monat";
    } else if (localType.value === "year") {
      bereich = "Jahr";
    }
    const vonDate = new Date(zeitbereichVon);
    const bisDate = new Date(new Date(zeitbereichBis).lastInMonth());
    currentZeitbereich = {
      bereich,
      von: vonDate,
      bis: bisDate,
    };
  }
  const modell: ALLModell | undefined = selectedAPI.modell;
  let tabUbergabe: number[] = [];
  if (tabMDialog) {
    tabUbergabe = tabMDialog;
  }
  if (modell && modell.abfrage && modell.MDialog && fromDialog !== true) {
    showDialog({
      title: "Modelldialog",
      width: 250,
      site: "ModellDialog",
      data: {
        currentZeitbereich,
        query: modell.abfrage,
      },
      okButton: true,
      onClose: (x: any) => {
        if (x.returnedData.length > 0) {
          tabUbergabe = x.returnedData;
        }
        if (x.dialogResult === true) {
          // daten holen aufrufen!
          getJSON(currentZeitbereich, tabUbergabe);
        }
        return true;
      },
    });
    return;
  } else {
    getJSON(currentZeitbereich);
  }
  getJSON(currentZeitbereich);
  // $api.getQuery(
  //   selectedAPI.kennung,
  //   // Done function
  //   (data: any) => me.dataLoaded(data),
  //   queryAIC,
  //   currentZeitbereich,
  //   0,
  //   false,
  //   false,
  //   "0",
  //   0,
  //   [],
  //   "",
  //   false,
  //   selectedAPI.aic
  // );
}
function getJSON(currentZeitbereich: any, tabUebergabe?: any) {
  // ModellDialog Übergabe einbauen....
  if (selectedAPI && selectedAPI.kennung) {
    AUApi.Current.getQuery(
      selectedAPI.kennung,
      // Done function
      (data: any) => dataLoaded(data),
      props.queryAIC ?? 0,
      currentZeitbereich,
      0,
      false,
      false,
      "0",
      0,
      vecStamm,
      "",
      false,
      selectedAPI.aic,
      tabUebergabe
    );
  }
}
function dataLoaded(data: AxiosResponse<QueryResponse>) {
  if (data.data.error !== undefined) {
    AUApi.Current.onfail(data.data.error);
    console.log(data.data.error);
    alert("ACHTUNG: " + data.data.error);
    emit("back");
    return;
  }

  const queryResponse = data.data;
  const csv = query2CSV(queryResponse, separator);
  createDownload(
    csv,
    "text/csv",
    queryResponse.header.bezeichnung ?? "download.csv"
  );
}

function selectedAPIChanged(args: any) {
  const selectAPILocal: any = apiAbfragen.find((m: any) => m.aic === args);
  selectedAPI = selectAPILocal;
}
function valueChanged(args: any) {
  if (!args) {
    return;
  }
  let bereich = "Tag";
  if (localType.value === "month") {
    bereich = "Monat";
  } else if (localType.value === "year") {
    bereich = "Jahr";
  }
  const vonDate = new Date(args);
  const bisDate = new Date(new Date(vonDate).lastInMonth());

  zeitbereich = {
    bereich,
    von: vonDate,
    bis: bisDate,
  };
}
</script>
<template>
  <v-card :loading="showLoading" max-width="600px" class="mt-2">
    <v-toolbar class="dvhBackground" density="compact">
      <v-toolbar-title style="color: white">
        {{ title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="white darken-2" icon="mdi-close" @click="goBack()"></v-btn>
    </v-toolbar>
    <v-card-text v-if="!showLoading && apiAbfragen.length > 0">
      <v-select
        :items="apiAbfragen"
        label="Auswahl"
        placeholder="Auswahl"
        item-title="bezeichnung"
        item-value="aic"
        @update:modelValue="selectedAPIChanged"
        v-model="selectedAPI"
        :no-data-text="
          globalsBezeichnung(
            Globals.Begriff,
            'Web_keineDaten_gefunden',
            'keine Daten gefunden'
          )
        "
        item-color="warning"
        variant="outlined"
        density="compact"
        color="warning"
      ></v-select>
      <v-row v-if="selectedAPI.aic">
        <v-col cols="3">
          <SelectZeitraum
            v-bind="props"
            :close-on-content-click="false"
            @updateZeitbereich="valueChanged"
          ></SelectZeitraum>
        </v-col>
        <v-col cols="9">
          <v-select
            label="Separator"
            :items="separators"
            item-title="label"
            item-value="sep"
            v-model="separator"
            item-color="warning"
            variant="outlined"
            density="compact"
            color="warning"
          />
        </v-col>
      </v-row>

      <!-- <v-col cols="9">
          <v-file-input
            v-model="file"
            label="File select"
            placeholder="Select"
            prepend-icon="mdi-paperclip"
            outlined
            :show-size="1000"
          >
          </v-file-input>
        </v-col>
        <v-col cols="3"> -->
    </v-card-text>
    <v-card-actions class="pa-0">
      <v-spacer></v-spacer>
      <v-btn
        v-if="selectedAPI.aic"
        variant="text"
        @click="downloadJson"
        prepend-icon="mdi-file-download-outline"
      >
        Download
      </v-btn>

      <v-btn  rounded="0" variant="tonal" @click="goBack()" icon="mdi-close"></v-btn>
    </v-card-actions>

    <v-card-text v-if="!showLoading && apiAbfragen.length === 0">
      {{
        globalsBezeichnung(
          Globals.Begriff,
          "Web_keineDaten_gefunden",
          "keine Daten gefunden"
        )
      }}
    </v-card-text>
  </v-card>
</template>

